module.exports = __webpack_public_path__ + "img/team.c0855649.svg";